<template>
  <div class="action-box">
    <Button :loading="btnLoading.co2Data" type="primary" class="btn-c-common" @click="calcu(3)">二氧化碳排放量自动计算</Button>
    <Button :loading="btnLoading.calcu" type="primary" class="btn-c-common btn-mg" @click="calcu(2)">自动计算</Button>
    <Button :loading="btnLoading.synchronousData" type="primary" class="btn-c-common" @click="calcu(1)">重新同步数据</Button>
  </div>
</template>

<script>
export default {
  props: {
    btnLoading: {
      type: Object
    }
  },
  methods: {
    calcu(type) {
      switch (type) {
        case 1:
          this.$emit('synchronousData')
          break;
        case 2:
          this.$emit('calcu')
          break;
        case 3:
          this.$emit('co2Data')
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.action-box {
  height: 40px;

  & > Button {
    float: right;
  }

  .btn-mg {
    margin: 0 10px;
  }
}
</style>